import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { ContactUpdate } from '../../services';

export const fetchContactUpdate = createAsyncThunk(
    'contactUpdate/fetchContactUpdate',
    async ({ file, country, city, district, address, company, companyDescription, phone, mail, location, fax, instagram, facebook, linkedin, youtube, specialField1, specialField2, specialField3, specialField4, specialField5 }) => {
        console.log("location", location);
        const response = await ContactUpdate(file, country, city, district, address, company, companyDescription, phone, mail, location, fax, instagram, facebook, linkedin, youtube, specialField1, specialField2, specialField3, specialField4, specialField5);
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const contactUpdateSlice = createSlice({
    name: 'contactUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchContactUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchContactUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchContactUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default contactUpdateSlice.reducer;
